import React from 'react'
import PropTypes  from 'prop-types'
import styles from './TeamMemberCard.module.scss'
import Avatar from '../Avatar/Avatar'
import InitialsBubble from '../InitialsBubble/InitialsBubble'
import {
  getPhotoForMember,
  getInitialsFromName
} from 'utils/Client/dedicatedTeam'
import { trackAnalyticsEvent } from 'analytics'
import classnames from 'classnames'
import PhoneNumber from '../../PhoneNumber/PhoneNumber'

const Card = (props) => {
  const {
    name,
    primaryText,
    secondaryText,
    avatarSize,
    phone,
    email,
    infoPosition,
    isAuthor,
    isMobile
  } = props

  const avatarImgPath = getPhotoForMember(name)

  const renderBubble = () => {
    if (!avatarImgPath) {
      const initials = getInitialsFromName(name)
      return <InitialsBubble initials={initials} size={avatarSize} />
    }
    return <Avatar data-test-id="avatar" imageUrl={avatarImgPath} size={avatarSize} />
  }

  return (
    <div className={classnames(styles.container, styles[`${infoPosition}Position`])}>
      <div className={classnames(styles.avatarContainer, isAuthor ? styles.notificationAvatar : '')}>
        {renderBubble()}
      </div>
      <div
        data-test-id="info"
        className={
          classnames(styles.infoContainer, avatarSize === 'medium' ? styles.infoContainerMedium : '')
        }>
        <div className={isAuthor ? styles.notificationBottomText : ''}>
          <div className={styles.primaryText}>{primaryText}</div>
          <div className={styles.secondaryText}>{secondaryText}</div>
          <div className={styles.separator} />
        </div>

        <div className={isAuthor ? styles.notificationBottom : ''}>
          {phone &&
          <div className={styles.phoneText}>
            <PhoneNumber
              number={phone}
              phoneType="mobile"
              showIcon={true}
              showLink={isMobile}
              trackEventName="FA Phone Number Clicked" />
          </div>
          }
          {email &&
          <div className={styles.emailText}>
            <a
              href={`mailto:${email}`}
              onClick={() => trackAnalyticsEvent('FA Email Clicked')}>
              <img data-test-id="emailIcon" className={styles.icon} alt="email" src="/images/email.png" />
              {email}
            </a>
          </div>
          }
        </div>

      </div>
    </div>
  )
}

Card.defaultProps = {
  name: '',
  avatarSize:  'large',
  phone: null,
  email: null,
  infoPosition: 'right',
  secondaryText: null,
  isAuthor: false,
  isMobile: false
}

Card.propTypes = {
  name: PropTypes.string,
  avatarSize: PropTypes.string,
  primaryText: PropTypes.node.isRequired,
  secondaryText: PropTypes.node,
  phone: PropTypes.node,
  email: PropTypes.node,
  infoPosition: PropTypes.oneOf([
    'left',
    'right',
    'bottom',
  ]),
  isAuthor: PropTypes.bool,
  isMobile: PropTypes.bool
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Client/Shared/TeamMemberCard/TeamMemberCard.jsx